/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Good
 * 
 * 1 = PartialDamage
 * 
 * 2 = Damaged
 */
export enum PartReceiptCondition {
  Good = 0,
  PartialDamage = 1,
  Damaged = 2
}
